import React from 'react';
import { trackException } from '../services/applicationInsights';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to Application Insights without allowing telemetry failures to cascade.
    try {
      trackException(error, {
        componentStack: errorInfo?.componentStack,
        errorBoundary: true
      });
    } catch {
      // Ignore telemetry failures in the boundary to keep fallback rendering safe.
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          marginTop: '50px' 
        }} role="alert" aria-live="assertive">
          <h2>Something went wrong</h2>
          <p>An error occurred. Please refresh the page or try again later.</p>
          {process.env.REACT_APP_ENVIRONMENT === 'development' && (
            <details style={{ marginTop: '20px', textAlign: 'left' }}>
              <summary>Error Details</summary>
              <pre>{this.state.error?.toString()}</pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;